import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { createPinia, PiniaVuePlugin } from "pinia";
import VueMask from "v-mask";
import i18n from "./i18n";
import GetTextPlugin from "vue-gettext";

Vue.use(GetTextPlugin, { translations: {}, silent: true });

Vue.use(VueMask);

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.config.productionTip = false;

// Allow the Apple Pay web component (<apple-pay-button>) loaded via apple-pay-sdk.js
Vue.config.ignoredElements = [/^apple-pay-button$/];

new Vue({
  vuetify,
  pinia,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
